import React, { useState } from "react";
import PropTypes from "prop-types";
import { language } from "../settings";
import { Eyecon } from ".";

export const Password = ({ password, setPassword, label, id }) => {
  const [showPassword, setShowPassword] = useState(false);
  const toggleVisibility = () => {
    setShowPassword((current) => !current)
  }

  const onChange = (e) => {
    setPassword(e.target.value);
  };

  return (
    <>
      <div className="flex w-full items-center relative mb-5">
        <input
          id={id}
          placeholder={label}
          type={showPassword ? "text" : "password"}
          name="password"
          autoComplete="off"
          aria-label={label}
          value={password}
          className="px-4 py-3 rounded text-black w-full password-input text-sm"
          onChange={onChange}
        />
        
        <Eyecon
          show={showPassword}
          toggleVisibility={toggleVisibility}
        />
      </div>
    </>
  );
};

Password.propTypes = {
  password: PropTypes.string.isRequired,
  setPassword: PropTypes.func.isRequired,
  label: PropTypes.string,
  id: PropTypes.string,
};

Password.defaultProps = {
  label: language("password"),
  id: undefined,
};
